import { io } from "socket.io-client";

const BASE_URL = "https://wanaapp.com";
// const BASE_URL = "http://localhost:3030"
// const BASE_URL = "http://38.242.200.169:3030";

export const socketConnection = io(BASE_URL);
